module.exports = __webpack_public_path__ + "static/media/Agent4.c988eaca.jpg";